import * as Yup from 'yup';

export const setupTotpSchema = Yup.object().shape({
    code: Yup.string().min(6).max(6).required(),
});
